
  export default {
    mounted() {
      this.el.addEventListener("dragenter", (e) => {
        e.preventDefault();
        this.el.classList.add("drag-over");
      });
      this.el.addEventListener("dragover", (e) => {
        e.preventDefault();
        this.el.classList.add("drag-over");
      });
      this.el.addEventListener("dragleave", (e) => {
        if (!this.el.contains(e.relatedTarget)) {
          this.el.classList.remove("drag-over");
        }
      });
      this.el.addEventListener("drop", () => {
        this.el.classList.remove("drag-over");
      });
    }
  }
